import React, { useEffect } from 'react';
import type { OAuthResult } from './vcs-connection-modal-form-oauth-authorization-button';
import VcsConnectionModalFormOauthAuthorizationButton from './vcs-connection-modal-form-oauth-authorization-button';
import { Row } from 'components/common/grid';
import { Alert, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import type { VcsConnectionsForm } from './access-card/use-connection-modal-access-card-form.hook';

export const VcsConnectionModalFormOauth: React.FC<VcsConnectionsForm> = ({ vcsConnection, form }) => {
  const [result, setResult] = React.useState<OAuthResult>({});

  const [, setAuthorizationId] = form.useManualField('authorizationId');

  useEffect(() => {
    if (result.error) {
      setAuthorizationId(undefined);
    } else if (result.authorizationId) {
      setAuthorizationId(result.authorizationId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);

  return (
    <>
      <Row style={{ marginBottom: '7px' }}>
        <Alert
          type="warning"
          message={
            <FormattedMessage id="organization.settings.agents.vcs-connections-modal.connection.oauth.warning" />
          }
        />
      </Row>
      <Row>
        <VcsConnectionModalFormOauthAuthorizationButton
          connectionType={vcsConnection.connectionType}
          vcsType={vcsConnection.type}
          onClosed={setResult}
          accessScope={vcsConnection.accessScope}
        />
      </Row>
      <Row style={{ marginBottom: '4px' }}>
        {result.error && (
          <Typography.Text strong underline type={'danger'}>
            <FormattedMessage
              id="organization.settings.agents.vcs-connections-modal.connection.oauth.failed"
              values={{ message: result.error }}
            />
          </Typography.Text>
        )}
        {result.accessScope && (
          <Typography.Text strong underline type={'success'}>
            <FormattedMessage
              id="organization.settings.agents.vcs-connections-modal.connection.oauth.success"
              values={{ accessScope: result.accessScope }}
            />
          </Typography.Text>
        )}
      </Row>
    </>
  );
};
